import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/css/specializedservices.css";

const services = [
  {
    title: "Startup Support",
    icon: "bi-rocket-takeoff",
    description: "Comprehensive assistance for new AC installations and system startups.",
    features: [
      "24/7 Technical Support with dedicated hotline",
      "Extended Warranty Coverage for peace of mind",
      "Expert Installation by certified technicians",
      "Quality Assurance with post-installation inspection",
    ],
   
  },
  {
    title: "Maintenance Plans",
    icon: "bi-shield-check",
    description: "Regular service plans to keep your system running at peak efficiency.",
    features: [
      "Scheduled Seasonal Inspections twice yearly",
      "Performance Optimization and efficiency tuning",
      "Filter Replacement and cleaning services",
      "System Updates and preventative maintenance",
    ],
   
  },
  {
    title: "Emergency Services",
    icon: "bi-alarm",
    description: "Fast response when you need immediate assistance with your system.",
    features: [
      "Rapid Response within 2 hours of your call",
      "Same-day Repair guaranteed or service is free",
      "Genuine Parts Replacement with warranty",
      "Comprehensive System Diagnosis and reporting",
    ],
  },
];

const SpecializedServices = () => {
  return (
    <section id="specialized" className="specialized-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Specialized Services</h2>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="service-card h-100">
                <div className="card-icon d-flex justify-content-center align-items-center">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <h3 className="card-title">{service.title}</h3>
                <p className="card-description">{service.description}</p>
                <ul className="feature-list text-start mb-2 list-unstyled">
                  {service.features.map((feature, fIndex) => (
                    <li key={fIndex} className="feature-content fw-normal ">
                      <i className="bi bi-check-circle-fill features-icon" style={{color:"#3c348d"}}></i>
                      <span className="px-2" style={{color:"#777777"}}>{feature}</span>
                    </li>
                  ))}
                </ul>
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecializedServices;